import React from 'react';
import { GlobalStyles as MuiGlobalStyles } from '@mui/material';
import type { Theme } from '@mui/material/styles';

export default function GlobalStyles() {
  const styles = (theme: Theme) => ({
    '*': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
      scrollbarWidth: 'thin',
      scrollbarColor: `${theme.palette.grey[300]} transparent`
    },
    '*::-webkit-scrollbar': {
      width: 4,
      height: 4
    },
    '*::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[300],
      borderRadius: 4,
      '&:hover': {
        backgroundColor: theme.palette.grey[400]
      }
    },
    html: {
      width: '100%',
      height: '100%',
      msTextSizeAdjust: '100%',
      WebkitOverflowScrolling: 'touch'
    },
    body: {
      width: '100%',
      height: '100%',
      backgroundColor: theme.palette.background.default
    },
    '#root': {
      width: '100%',
      height: '100%'
    },
    input: {
      '&[type=number]': {
        MozAppearance: 'textfield',
        '&::-webkit-outer-spin-button': { margin: 0, WebkitAppearance: 'none' },
        '&::-webkit-inner-spin-button': { margin: 0, WebkitAppearance: 'none' }
      }
    },
    // textarea: {
    //   '&::-webkit-input-placeholder': { color: theme.palette.text.disabled },
    //   '&::-moz-placeholder': { opacity: 1, color: theme.palette.text.disabled },
    //   '&:-ms-input-placeholder': { color: theme.palette.text.disabled },
    //   '&::placeholder': { color: theme.palette.text.disabled }
    // },
    // a: { color: theme.palette.primary.main },
    img: {
      display: 'block',
      maxWidth: '100%'
    },
    '.blur-up': {
      WebkitFilter: 'blur(5px)',
      filter: 'blur(5px)',
      transition: 'filter 400ms, -webkit-filter 400ms'
    },
    '.blur-up.lazyloaded': {
      WebkitFilter: 'blur(0)',
      filter: 'blur(0)'
    },
    // Calmer skeleton animation for focused learning (slightly slower)
    '.MuiSkeleton-wave::after': {
      animationDuration: '2s'
    },
    // Respect reduced motion for accessibility
    '@media (prefers-reduced-motion: reduce)': {
      '.MuiSkeleton-root': {
        animation: 'none !important'
      }
    }
  });

  return <MuiGlobalStyles styles={styles} />;
}
